<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_down">
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title">
              质检台账详情
            </div>
            <div class="content_head_button">
              <lk-button img="back.png" @click="goBack" type="lk_button_blue">返回</lk-button>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>编号</span>
              </div>
              <el-input v-model="WarehouserInfo.number" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>车牌号</span>
              </div>
              <el-input v-model="dataSet.carSheepNumber" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>发货单位</span>
              </div>
              <el-input v-model="dataSet.deliverCompanyCn" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>包装方式</span>
              </div>
              <el-input v-model="dataSet.packingWay" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食品种</span>
              </div>
              <el-input v-model="dataSet.grainKind" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食产地</span>
              </div>
              <el-input v-model="dataSet.grainArea" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食性质</span>
              </div>
              <el-input v-model="dataSet.foodNature" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮权所属</span>
              </div>
              <el-input v-model="dataSet.grainBelongCn" placeholder="" disabled maxlength="15"></el-input>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>通知单编号</span>
              </div>
              <el-input v-model="notice.number" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食等级</span>
              </div>
              <el-input v-model="notice.grainLevel" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>数量</span>
              </div>
              <el-input v-model="notice.primitiveNumber" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>下发单位</span>
              </div>
              <el-input v-model="notice.lssueUnit" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>下发时间</span>
              </div>
              <el-input v-model="notice.issueTime" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only_remark">
              <div class="content_element_only_title">
                <span>通知单备注</span>
              </div>
              <el-input type="textarea" :rows="2" placeholder="" v-model="notice.remark" disabled></el-input>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>仓房</span>
              </div>
              <el-input v-model="WarehouserInfo.barnNameFi" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>毛重(kg)</span>
              </div>
              <el-input v-model="WeightInfo.weight" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>皮重(kg)</span>
              </div>
              <el-input v-model="TareWeight.tareWeight" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>现场增扣量(%)</span>
              </div>
              <el-input v-model="WarehouserInfo.nowAddReduceNumber" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>净重(kg)</span>
              </div>
              <el-input v-model="TareWeight.netWeight" placeholder="" disabled maxlength="15"></el-input>
            </div>
          </div>
          <div class="content_element" style="border-bottom: 0">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验结果</span>
              </div>
              <el-input v-model="QualityCheckInfo.checkResult" placeholder="" disabled maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检测增扣量(%)</span>
              </div>
              <el-input v-model="QualityCheckInfo.addReduceNumber" placeholder="" disabled maxlength="15"></el-input>
            </div>
          </div>
          <div class="Notice_alert">
            <el-table border :data="reportSons" style="width: 100%">
              <el-table-column prop="assayName" label="质检项" align="center"></el-table-column>
              <el-table-column prop="assayValue" label="检测值" align="center"></el-table-column>
              <el-table-column prop="addReduceNumber" label="增扣量(%)" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
        <!--        保存提示-->
        <!--        <el-dialog title="提示" :visible.sync="alertShow" width="30%" style="margin-top: 20vh">-->
        <!--          <span>是否确认保存</span>-->
        <!--          <span slot="footer" class="dialog-footer">-->
        <!--            <el-button @click="alertShow = false">取消</el-button>-->
        <!--            <el-button type="primary" @click="alertShow = false">确认</el-button>-->
        <!--          </span>-->
        <!--        </el-dialog>-->
      </div>
    </div>
  </div>
</template>

<script>
import {httpToken} from "@/utils/http";
import qs from "qs";

export default {
  name: 'ReportAdd',
  data() {
    return {
      dataSet: {
        carSheepNumber: '',
        deliverCompanyCn: '',
        packingWay: '',
        grainKind: '',
        grainArea: '',
        quantity: '',
      },
      notice: {
        number: '',
        grainLevel: '',
        quantity: '',
        remark: '',
        lssueUnit: '',
        issueTime: '',
      },
      TareWeight: {
        netWeight: '',
        warehouseNumber: '',
      },
      WeightInfo: {
        weight: '',
      },
      QualityCheckInfo: {
        checkResult: '',
        addReduceNumber: '',
      },
      WarehouserInfo: {
        number:'',
        barnNameFi: '',
        nowAddReduceNumber: '',
        serialNumber: '',
      },
      reportSons: [],
      barnInfoList: [],
      testTypeList: [],
      resultList: [
        {
          label: '合格',
          value: '合格',
        },
        {
          label: '不合格',
          value: '不合格',
        }
      ],
      alertShow: false,
      ids: '',
      backModule: ''
    }
  },
  methods: {
    // 获取数据详情
    getData(id) {
      httpToken({
        method: 'post',
        url: '/granary-quality-ledger/showAllOne',
        data: qs.stringify({id: id})
      }).then(res => {
        // console.log(res)
        let Data = res.data.data
        this.dataSet = Data.GoodsBaseInfo
        if(Data.GoodsBaseInfo.noticeT!==null){
          this.notice = Data.GoodsBaseInfo.noticeT
        }
        this.TareWeight = Data.TareWeight
        this.WeightInfo = Data.WeightInfo
        this.QualityCheckInfo = Data.QualityCheckInfo
        this.reportSons = Data.QualityCheckInfo.infos
        this.WarehouserInfo = Data.WarehouserInfo
        // this.dataSet = res.data.data.GranaryQualityReport
        // this.reportSons = res.data.data.GranaryQualityReportSon
      })
    },
    // 返回
    goBack() {
      this.$emit('update:comName', this.backModule)
    },
    // 获取仓房信息
    getBarnData(number) {
      httpToken({
        method: 'post',
        url: '/barnInfo/showOne',
        data: qs.stringify({id: number})
      }).then(res => {
        // console.log(res)
        let barnData = res.data.data
        this.dataSet.grainNature = barnData.grainNature
        this.dataSet.grainBelong = barnData.grainBelong
        this.dataSet.warehouseType = barnData.barType
        this.dataSet.foVariety = barnData.grainKind
        this.dataSet.foGrade = barnData.grainLevel
        this.dataSet.quantity = barnData.actualSize
      })
    },
    // 获取化验具体数据
    AssayData() {
      if (this.dataSet.foVariety !== '' && this.dataSet.type !== '') {
        httpToken({
          method: 'post',
          url: '/granary-quality-report/getCheckM',
          data: qs.stringify({
            grKind: this.dataSet.foVariety,
            type: this.dataSet.type
          })
        }).then(res => {
          // console.log(res.data.data)
          let AssayData = res.data.data
          this.dataSet.template = AssayData.mouldName
          this.reportSons = []
          AssayData.details.forEach((item) => {
            this.reportSons.push({
              value: "",
              item: item.chItemCn,
              standard: item.chDescribe,
              result: ""
            })
          })
        })
      }
    }
  },
  mounted() {
    if (this.$store.state.Quality.qualityId !== '') {
      this.getData(this.$store.state.Quality.qualityId)
    }
    if (this.$store.state.Quality.qualityBack) {
      this.backModule = this.$store.state.Quality.qualityBack
    }
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0
  }

  .content_head_button {
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-select {
        width: 100%;
      }

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .input-with-select {
        .el-select {
          width: 65px;
        }

        ::v-deep .el-input__inner {
          text-transform: uppercase;
        }
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.content_element {
  margin-top: 50px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEBEB;
  text-align: right;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .content_element_only {
    width: 33.3333%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep .el-select {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    ::v-deep .el-cascader {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    /*样式穿透*/
    ::v-deep .el-input {
      //width:12.5vw;
      width: 50%;
      background: #F4F7FD;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }
  }

  .content_element_only_remark {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep.el-textarea {
      width: 83.333%;
    }
  }
}

.Notice_alert {
  font-size: 14px;
  color: #969696;

  ::v-deep .el-table {
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }

  ::v-deep .el-table th {
    background-color: #f4f7fd;
    color: #2A2A2A;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 10px 0;
  }

  ::v-deep .el-table thead {
    color: #969696;
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }
}
</style>
